import type {
  TriggerIntegrationSpec,
  TriggerIntegrationStruct,
} from '@cohort/shared/schema/apps/app';
import {z} from 'zod';

export const InstagramConnectAccountTriggerConfigSchema = z.object({});
export type InstagramConnectAccountTriggerConfig = z.infer<
  typeof InstagramConnectAccountTriggerConfigSchema
>;

export const InstagramConnectAccountVerificationAttemptDataSchema = z.object({
  memberHandle: z.string().nullable(),
});
export type InstagramConnectAccountVerificationAttemptData = z.infer<
  typeof InstagramConnectAccountVerificationAttemptDataSchema
>;

export type InstagramConnectAccountTriggerStruct = TriggerIntegrationStruct<
  'instagram.connect-account',
  InstagramConnectAccountTriggerConfig,
  InstagramConnectAccountVerificationAttemptData
>;
export const InstagramConnectAccountTriggerIntegrationSpec: TriggerIntegrationSpec<InstagramConnectAccountTriggerStruct> =
  {
    id: 'instagram.connect-account' as const,
    type: 'verification',
    configurableMaxAttempts: false,
    configSchema: InstagramConnectAccountTriggerConfigSchema,
    verificationAttemptDataSchema: InstagramConnectAccountVerificationAttemptDataSchema,
    verificationAttemptInputSchema: z.object({}),
  };
